define(function (require) {
    'use strict';

    var $ = require('jquery'),
        stringFormat = require('../plugins/hbs/helpers/format');

    require('../lib/jquery.delayedobserver');

    var dataKey = 'charlimit';

    var hasNativeTextareaSupport = 'maxLength' in $('<textarea>')[0];

    var CharLimiter = function (elem, limit, options) {
        options.status = $(options.status);

        var self = $(elem);

        if (!self.is('input:text, textarea')) {
            throw 'Invalid element type.';
        }

        // assume native support for textbox maxlength
        var hasNativeSupport = !self.is('textarea') || hasNativeTextareaSupport;

        this.elem = elem;
        limit = this.limit = limit || self[0].maxLength;

        this.options = options;

        var updateStatus = options.status.length ?
            function () {
                var chars = limit - self.val().length;
                if (chars < 0) {
                    self.val(self.val().substring(0, limit));
                    chars = 0;
                }
                var statusMsg = (chars <= options.startAt) ? stringFormat(options.format, chars) : '';
                options.status.text(statusMsg);
            } : $.noop;

        if (hasNativeSupport) {
            // ensure attribute is set
            self[0].maxLength = limit;
            $(elem).keyup(updateStatus).delayedObserver(updateStatus);
        } else {
            $(elem).keyup(function (e) {
                var chars = limit - self.val().length;
                if (chars < 0) {
                    e.stopPropagation();
                }
                updateStatus();
            }).keydown(function (e) {
                var value = self.val();
                var chars = value.length;
                if (e.which === 46 /* delete */ || e.which === 8 /* backspace */) return;
                if (chars >= limit) e.stopPropagation();
                if (chars > limit) {
                    self.val(value.substring(0, limit));
                }
            }).delayedObserver(updateStatus);
        }
    };

    $.fn.extend({
        charlimit: function (limit, options) {
            options = $.extend({ status: '', startAt: limit, format: '{0}' }, options);
            if (!this.length) {
                return this;
            }

            return this.each(function () {
                $(this).data(dataKey, new CharLimiter(this, limit, $.extend({}, options)));
            });
        }
    });
});
